<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <ParametricSearchHeader :isPublic="false"></ParametricSearchHeader>
        <ParametricSearchComponent :isPublic="false"></ParametricSearchComponent>
    </div>
</template>

<script>
    import ParametricSearchComponent from "../../components/parametric-search/ParametricSearch";
    import ParametricSearchHeader from "../../components/parametric-search/ParametricSearchHeader";

    export default {
        name: "MyParametricTable",
        components: {
            ParametricSearchComponent,
            ParametricSearchHeader,
        },
    }
</script>
